import jsPDF from 'jspdf';  
import 'jspdf-autotable';  
  
export const generateInvoicePDF = (invoiceData, settings, applications) => {  
    const { bankingDetails, contactDetails } = settings;  
    const { contestantName, feeBreakdown } = invoiceData;  
    const baseFee = feeBreakdown.base_fee;
    const additionalFee = feeBreakdown.additional_fee;
    const totalFee = feeBreakdown.total_fee_unpaid;  
    const groupFee = feeBreakdown.group_fee;
  
    const doc = new jsPDF();  
    const pageHeight = doc.internal.pageSize.height;  
    const margin = 14;  
    let cursorY = margin + 8;  
  
    const addNewPage = () => {  
        doc.addPage();  
        cursorY = margin;  
    };  
  
    doc.setFontSize(18);  
    doc.setFont('helvetica', 'bold');  
    doc.text('Invoice Details', margin, cursorY);  
    cursorY += 10;  

    doc.setFontSize(11);  
    doc.setFont('helvetica', 'bold');  
    const vatText = "BEYOND 2000 PERFORMING ARTS\nVat NO: 4380280877";  
    const pageWidth = doc.internal.pageSize.width;  
    doc.text(  
        vatText,  
        pageWidth - margin, // right-aligned with same margin  
        margin + 2,         // slightly down from the top  
        { align: 'right' }  
    );  
    
    // Restore font for main content  
    doc.setFontSize(12);  
    doc.setFont('helvetica', 'normal');  
    
    cursorY += 10;  
  
    doc.setLineWidth(0.5);  
    doc.line(margin, cursorY, doc.internal.pageSize.width - margin, cursorY);  
    cursorY += 10;  
  
    doc.setFontSize(12);  
    doc.setFont('helvetica', 'normal');  
    doc.text(`Contestant: ${contestantName}`, margin, cursorY);  
    cursorY += 10;  

    doc.text(`Base Fee: R ${baseFee}`, margin, cursorY);  
    cursorY += 10;  

    doc.text(`Additional Fee: R ${additionalFee}`, margin, cursorY);  
    cursorY += 10;  

    doc.text(`Group Fee: R ${groupFee}`, margin, cursorY);
    cursorY += 10;  
  
    doc.text(`Total Fee: R ${totalFee}`, margin, cursorY);  
    cursorY += 10;  

    doc.line(margin, cursorY, doc.internal.pageSize.width - margin, cursorY);  
    cursorY += 10;  
  
    const eventDetails = applications.map(app => {  
        const eventName = app?.event?.name ?? "Unknown Event";  
        const eventStyle = app?.event?.style ?? "Unknown Style";  
        const isSolo = app?.event?.solo_bool ?? false;  
        return [eventName, eventStyle, isSolo ? 'Solo' : 'Group'];  
    });  
  
    doc.autoTable({  
        head: [['Event Name', 'Style', 'Type']],  
        body: eventDetails,  
        startY: cursorY,  
        theme: 'grid',  
        styles: {  
            halign: 'center',  
            valign: 'middle',  
        },  
        headStyles: {  
            fillColor: [41, 128, 185],  
            textColor: [255, 255, 255],  
            fontStyle: 'bold',  
        },  
        didDrawPage: (data) => {  
            cursorY = data.cursor.y + 10;  
        },  
    });  
  
    if (cursorY + 10 > pageHeight) addNewPage();  
    doc.line(margin, cursorY, doc.internal.pageSize.width - margin, cursorY);  
    cursorY += 10;  
  
    if (cursorY + 40 > pageHeight) addNewPage();  
    doc.text('Contact Details:', margin, cursorY);  
    cursorY += 10;  
    doc.setFont('helvetica', 'italic');  
    doc.text(`Email address: ${contactDetails.email}`, margin, cursorY);  
    cursorY += 10;  
    doc.text(`Website: ${contactDetails.website}`, margin, cursorY);  
    cursorY += 10;  
    doc.text(`Emergency ONLY: ${contactDetails.emergencyContact.name} - ${contactDetails.emergencyContact.phone}`, margin, cursorY);  
  
    doc.save(`Invoice_${contestantName}.pdf`);  
};  